import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Container,
  Fab,
  Hidden,
  IconButton,
  List,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { Home, KeyboardArrowUp } from "@material-ui/icons";

import { availablePages, menuButtons } from "../assets/menuButtons";

import BackToTop from "./BackToTop";
import HideOnScroll from "./HideOnSCroll";
import LanguageSwitcher from "./LanguageSwitcher";
import MenuButton from "./MenuButton";
import SideDrawer from "./SideDrawer";

const useStyles = makeStyles({
  linkText: {
    textDecoration: "none",
    textTransform: "uppercase",
    color: "#504538",
  },
  navbarDisplayFlex: {
    display: "flex",
    justifyContent: "space-between",
  },
  navListDisplayFlex: {
    display: "flex",
    justifyContent: "space-between",
  },
});

const TopMenu = (props) => {
  const classes = useStyles();
  const { language } = useContext(LanguageContext);

  return (
    <>
      <HideOnScroll style={{ zIndex: 999 }}>
        <AppBar position="fixed" style={{ backgroundColor: "#f6f6f6" }}>
          <Toolbar component="nav">
            <Container maxWidth="xl" className={classes.navbarDisplayFlex}>
              <IconButton edge="start" aria-label="home">
                <Link to="/" style={{ textDecoration: "none" }}>
                  <Typography
                    style={{
                      fontSize: 25,
                      fontFamily: "Raleway",
                      fontWeight: "bold",
                      color: "#504538",
                      padding: 5,
                    }}
                  >
                    {localize("app.name", language)}
                    <img
                      src={`${process.env.PUBLIC_URL}/images/zig.png`}
                      style={{
                        height: 20,
                        position: "absolute",
                        top: 10,
                        left: 70,
                        zIndex: 1000,
                      }}
                    />
                  </Typography>
                </Link>
              </IconButton>
              <Hidden smDown>
                <List
                  component="nav"
                  aria-labelledby="main navigation"
                  className={classes.navListDisplayFlex}
                >
                  {availablePages.map((menuButton, index) => (
                    <MenuButton
                      meta={menuButtons[menuButton]}
                      key={`headerButton${index}`}
                    />
                  ))}
                </List>
              </Hidden>
              <LanguageSwitcher />
              <Hidden mdUp>
                <SideDrawer />
              </Hidden>
            </Container>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar id="back-to-top-anchor" />

      <BackToTop>
        <Fab
          style={{ backgroundColor: "#ffc26c", color: "#504538" }}
          size="large"
          aria-label="scroll back to top"
        >
          <KeyboardArrowUp />
        </Fab>
      </BackToTop>
    </>
  );
};

export default TopMenu;
